import { render, staticRenderFns } from "./bookingDetails.vue?vue&type=template&id=24b8ee51&scoped=true&"
import script from "./bookingDetails.vue?vue&type=script&lang=js&"
export * from "./bookingDetails.vue?vue&type=script&lang=js&"
import style0 from "./bookingDetails.vue?vue&type=style&index=0&id=24b8ee51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8ee51",
  null
  
)

export default component.exports